import * as z from 'zod'
import {
  DiskTypeEnum,
  RubberTypeEnum,
  WheelCodeEnum,
} from '~/shared/config/enums'
import { dateSchema } from '~/shared/lib/schemas'
import { ApiModel } from './core'

const attributesSchema = z.object({
  diskType: z.nativeEnum(DiskTypeEnum),
  rubberType: z.nativeEnum(RubberTypeEnum),
  wheelCode: z.nativeEnum(WheelCodeEnum),
})

const schema = z
  .object({
    createdAt: dateSchema,
    updatedAt: dateSchema,
  })
  .merge(attributesSchema)

export type InspectionWheelsStateAttributes = z.infer<typeof schema>

export class InspectionWheelsState extends ApiModel<
  typeof schema,
  InspectionWheelsStateAttributes
> {
  static jsonApiType = 'inspection-wheels-states'

  static schema = schema

  getDiskType(): DiskTypeEnum {
    return this.getAttribute('diskType')
  }

  getRubberType(): RubberTypeEnum {
    return this.getAttribute('rubberType')
  }

  getWheelCode(): WheelCodeEnum {
    return this.getAttribute('wheelCode')
  }
}
